import { DoneButton } from 'components/blue-button'
import DismissButton from 'components/dismiss-button'
import Dropdown from 'components/selector'
import UploadBox from 'components/upload-box'
import styles from 'css/components/classroom/add-new-student-overlay.module.css'
import { useState } from 'react'

export const UpdateClassOverlay = ({ setShowUpdateClassOverlay }) => {
    const [isLoading, setIsLoading] = useState(false)

    const handleUpdateClass = () => {
        console.log('Create Classroom')
        setShowUpdateClassOverlay(false)
    }

    return (
        <div className="overlay">
            <div className="overlay-content-container">
                <div className="overlay-content-header">
                    <h3>Update Class List</h3>
                    <DismissButton onClick={() => setShowUpdateClassOverlay(false)} />
                </div>
                <div className={`overlay-content-body`}>
                    <div className={styles.flexColumn}>
                    Class list: <br></br>
                        <div className={styles.bulkUploadText}>
                            BULK UPLOAD: You can upload an accepted file as long as it has one record per row. Ensure that your spreadsheet columns match the right data points as shown in the template below.</div>
                    </div>
                    <div className="upload-box-row">
                        <UploadBox
                            name="Upload Class List"
                        acceptedFileTypes={[
                            'text/csv',
                            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            'application/vnd.ms-excel'
                        ]} 
                            acceptedFileExtensionsText=".CSV, .XLSX, .XLS"
                            onFileUpload={() => {}}
                        />
                    </div>
                    {/* Or manually
                     enter your class list here: */}
                    {/* <ClassListInput /> */}
                    <div className="alignRight">
                        <DoneButton  onClick={handleUpdateClass} />
                    </div>
                </div>
            </div>
        </div>
    )
}